import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=d83d49a0&scoped=true&"
import script from "./VideoModule.vue?vue&type=script&lang=js&"
export * from "./VideoModule.vue?vue&type=script&lang=js&"
import style0 from "./VideoModule.vue?vue&type=style&index=0&id=d83d49a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83d49a0",
  null
  
)

export default component.exports